import { render, staticRenderFns } from "./FormFieldDesignerDialog.vue?vue&type=template&id=08b63e30&"
import script from "./FormFieldDesignerDialog.vue?vue&type=script&lang=js&"
export * from "./FormFieldDesignerDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports